import { templateNameId, templateNameType } from "../../../../../../../shared_lsi_sg/templateData";
import { useValidationOxygen } from "./useValidationOxygen";
import { useValidationVentilo } from "./useValidationVentilo";
import { useValidationSleep } from "./useValidationSleep";
import { useValidationConcentrator } from "./useValidationConcentrator";
import { useValidationSleepStudy } from "./useValidationSleepStudy";
import { useValidationTherapy } from "./useValidationTherapy";
import { useValidationScoredDiagnosticStudy } from "./useValidationScoredDiagnosticStudy";
import { useValidationTitration } from "./useValidationTitration";
import { useValidationConcentratorFixed } from "./useValidationConcentratorFixed";
import { useValidationConcentratorPortable } from "./useValidationConcentratorPortable";
import { useValidationBombolaLegge64896 } from "./useValidationBombolaLegge64896";
import { useValidationVoxiSudFooter } from "./useValidationVoxiSudFooter";
import { useValidationOxygenPlusConcentrator } from "./useValidationOxygenPlusConcentrator";
import { required } from "../../../../../../../shared/utils/forms/utils/validationType";


export const useValidationProduct = (template: string, t: any, dataForm: any) => {
  const voxiSudFooterValidations = useValidationVoxiSudFooter(t);
  const withVoxiSudFooter = (validations: any[]) => [
    ...validations,
    ...voxiSudFooterValidations
  ];
  const oxygenPlusConcentratorVoxiSudValidations = [
    ...withVoxiSudFooter(useValidationOxygenPlusConcentrator(t, dataForm)),
    {
      name: "numeroSerbatoiAutorizzati",
      validations: [
        {
          name: required,
          params: {
            name: t("voxiSud.numeroSerbatoiAutorizzati")
          }
        }
      ]
    }
  ];

  const templates = {
    [templateNameId[templateNameType.note]]: {},
    [templateNameId[templateNameType.ossigeno]]: useValidationOxygen(t, dataForm),
    [templateNameId[templateNameType.ventiloterapia]]: useValidationVentilo(t, dataForm),
    [templateNameId[templateNameType.sleep]]: useValidationSleep(t, dataForm),
    [templateNameId[templateNameType.concentrator]]: useValidationConcentrator(t, dataForm),
    [templateNameId[templateNameType.sleepStudy]]: useValidationSleepStudy(t, dataForm),
    [templateNameId[templateNameType.therapy]]: useValidationTherapy(t, dataForm),
    [templateNameId[templateNameType.scoredDiagnosticStudy]]: useValidationScoredDiagnosticStudy(t, dataForm),
    [templateNameId[templateNameType.titration]]: useValidationTitration(t, dataForm),
    [templateNameId[templateNameType.concentratorFixed]]: useValidationConcentratorFixed(t, dataForm),
    [templateNameId[templateNameType.concentratorPortable]]: useValidationConcentratorPortable(t, dataForm),
    [templateNameId[templateNameType.oxygenPlusConcentrator]]: useValidationOxygenPlusConcentrator(t, dataForm),
    [templateNameId[templateNameType.bombolaLegge64896]]: useValidationBombolaLegge64896(t),
    [templateNameId[templateNameType.concentratorFixedVoxiSud]]: withVoxiSudFooter(useValidationConcentratorFixed(t, dataForm)),
    [templateNameId[templateNameType.concentratorPortableVoxiSud]]: withVoxiSudFooter(useValidationConcentratorPortable(t, dataForm)),
    [templateNameId[templateNameType.oxygenPlusConcentratorVoxiSud]]: oxygenPlusConcentratorVoxiSudValidations
  }

  return {
    validations: template && templates[template] ? templates[template] : {}
  }

}
